import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AssistanceProvided, ContactTypes, ExtensionActivity, ExtensionActivityType, PracticeChange, PracticeChangeActivity} from '../../../../functions/src/types';
import {RSDialogComponentModel} from '../../../libs/rsnotify/rsdialog.component.model';
import {UserService} from '../../services/user.service';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import {DataService, ResolveCategory} from "../../services/data.service";
import {ReplaySubject, Subscription} from "rxjs";
import invert from "invert-color";
import {RSDialogService} from "../../../libs/rsnotify/rsdialog.service";
import * as moment from 'moment';
import {RSValidatorFormDirective} from "../../../libs/rsvalidator/rsvalidator.directive";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-add-practice-change',
  templateUrl: './add-practice-change.component.html',
  styleUrls: ['./add-practice-change.component.scss']
})
export class AddPracticeChangeComponent extends RSDialogComponentModel implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('form') inputForm: RSValidatorFormDirective;
  @ViewChild('actionButtons', {static: true, read: TemplateRef}) actionButtons: TemplateRef<any>;
  practiceChange: PracticeChange = {} as PracticeChange;

  activitySub: Subscription;
  activityTypes: PracticeChangeActivityDisplay[] = [];
  // selectActivity: ExtensionActivityTypeDisplay;
  // filteredActivities: ReplaySubject<ExtensionActivityTypeDisplay[]> = new ReplaySubject<ExtensionActivityTypeDisplay[]>(1);
  // activitySearch = '';
  private practiceChangeActivitySubject = new ReplaySubject<any[]>(1);
  filteredPracticeChangeActivities = this.practiceChangeActivitySubject.asObservable();


  constructor(
    private userService: UserService,
    public dataService: DataService,
    public rsDialogService: RSDialogService,
    private resolveCategory: ResolveCategory) {
    super();
    this.activitySub = this.dataService.practiceChangeActivities.subscribe(v => {
      this.activityTypes = v.map(a => {
        const category = this.resolveCategory.transform(a.category);
        return {
          ...a,
          categoryName: category?.name,
          categoryColor: category?.color,
          categoryIcon: category?.icon,
        } as PracticeChangeActivityDisplay;
      });
    });
  }

  ngOnInit(): void {
    this.dataService.practiceChangeActivities.subscribe(practiceChangeActivities => {
      this.practiceChangeActivitySubject.next(practiceChangeActivities);
    });

    this.updatePracticeChangeInfo(this.dialogValues?.practiceChange || {});
    this.dialogValuesUpdated.subscribe(v => this.updatePracticeChangeInfo(v?.practiceChange || {}));

  }

  updatePracticeChangeInfo(input: any) {
    this.practiceChange = {
      id: input.id || null,
      date: typeof input.date === 'number' ? moment(input.date, 'X').toDate() : new Date(),
      activity: input.activity || null,
      notes: input.notes || '',
      user: input.user || this.userService.activeUserId,
      property: input.property || '',
    } as PracticeChange;
  }

  invertColor(hex) {
    return invert(hex || '#ffffff', true);
  }

  activityById(activityId: string) {
    return this.activityTypes.find(at => at.id === activityId);
  }


  cancel() {
    this.dialogHandles.close(RSDialog.defaultValues.CANCEL);
  }

  savePracticeChange() {
    if (!this.inputForm.isValid(true)) {
      return;
    } else {
      const practiceChange: PracticeChange = {} as PracticeChange;
      Object.assign(practiceChange, this.practiceChange);
      practiceChange.date = +moment(practiceChange.date).format('X');
      this.dialogValues.practiceChange = practiceChange;
      this.dialogHandles.close(RSDialog.defaultValues.YES);
    }
  }

  ngAfterViewInit(): void {
    this.dialogHandles.buttonTemplateRef = this.actionButtons;
    this.dialogHandles.buttonTemplateAttach();
  }

  ngOnDestroy() {
    if (this.activitySub) {
      this.activitySub.unsubscribe();
    }
  }

}

interface PracticeChangeActivityDisplay extends PracticeChangeActivity {
  categoryName: string;
  categoryIcon: string;
  categoryColor: string;
}
